import React from "react";
import LoaderGif from "../../images/365 loading.gif";

/**
 * Task 37 V2 — the product's loading indicator, as a component.
 *
 * THE PORTAL HAS NO SHARED LOADER. The same gif is imported and sized by hand in 43 files, which is
 * why these screens ended up with a text-only "Loading…" instead: there was nothing to reuse, and
 * the newest screens quietly grew their own convention. Against any other page in the product they
 * then looked like they were not loading at all.
 *
 * Nothing here is new. It is the markup those 43 copies already use, in one place, so the next
 * screen does not have to make the same decision again.
 *
 * The gif is 2.1MB, which would be a poor choice on its own — but App.js renders this exact asset in
 * the branding overlay on EVERY page load, so it is already in the browser cache long before anyone
 * reaches these screens. Choosing a lighter file would mean a second fetch, not a cheaper one.
 *
 * @param inline Small and in the flow of text, for beside a heading. Default is the block form:
 *               centred and panel-sized, which is what a panel standing in for its own contents
 *               wants.
 */
export default function Loader({ inline }) {
    if (inline) {
        return (
            <img
                src={LoaderGif}
                alt="loading"
                style={{ height: "16px", verticalAlign: "middle" }}
            />
        );
    }

    return (
        <div style={{ textAlign: "center" }}>
            <img src={LoaderGif} alt="loading" style={{ height: "50px" }} />
        </div>
    );
}
